import axios from "axios";

export const getBackendApiBaseUrl = () => {
    return '/test_be';
    //return 'https://backend.kmbat.uz/test_be';
};

/*axios.interceptors.response.use(
    (response) => response,
    (error) => {
        // Check if the error status is 401
        if (error.response && error.response.status === 401) {
            // Redirect to the index page or any other page as needed
            const navigate = useNavigate ();
            navigate('/');
        }

        // You can also handle other error cases here if needed

        return Promise.reject(error);
    }
);*/


export default Object.assign( axios.create({
    baseURL: getBackendApiBaseUrl()
}), {
    isCancel: axios.isCancel,
    CancelToken: axios.CancelToken
});

